import { CloseIcon } from "@chakra-ui/icons";
import { Button, Flex, IconButton, Text } from "@chakra-ui/react";

import React from "react";
import { SectionHeading } from "../../../atoms/Headings";
import { DataSourceDrawerFooter } from "../components/DataSourceDrawerFooter";
import { DataSourceDrawHeader } from "../components/DataSourceDrawerHeader";
import {
  SelectDataSource,
  SelectDataSourceProps,
} from "../dataSourceSelector/SelectDataSource";
import { SkipForNowButton } from "../SelectFirstDataSource";

export function SelectDataSourcePanel({
  onClose,
  searchValue,
  filter,
  onSearchTermChange,
  onFilterChange,
  onSelect,
  enableSkipForNow,
}: {
  onClose?: () => void;
  enableSkipForNow?: boolean;
} & SelectDataSourceProps): React.ReactElement {
  return (
    <>
      <DataSourceDrawHeader>
        <SectionHeading>Add Data Source</SectionHeading>
        {onClose && (
          <IconButton
            aria-label="Close"
            boxSize="2.5rem" // same as "md", but set explicitly to the same size as the datasource icon, so there is no layout shift between screens
            size="md"
            fontSize="md"
            variant="ghost"
            colorScheme="gray"
            icon={<CloseIcon />}
            onClick={onClose}
          />
        )}
      </DataSourceDrawHeader>

      {enableSkipForNow && (
        <Flex mt={4} px={4} direction="column" w="full" align="flex-start">
          <SkipForNowButton mb={4} />
          <Text>Select your exchange, wallet or other platform used.</Text>
        </Flex>
      )}
      <SelectDataSource
        searchValue={searchValue}
        filter={filter}
        onSearchTermChange={onSearchTermChange}
        onFilterChange={onFilterChange}
        onSelect={onSelect}
      />
      <DataSourceDrawerFooter>
        {onClose && (
          <Button variant="outline" colorScheme="gray" onClick={onClose}>
            Close
          </Button>
        )}
      </DataSourceDrawerFooter>
    </>
  );
}
